<template>
  <radio-group
    v-model="model"
    class="max-w-md space-y-2 md:space-y-3"
  >
    <radio-group-label class="text-gray-700">
      {{ label }}
    </radio-group-label>

    <radio-group-option
      v-for="[ value, text ] in items"
      :key="text"
      class="
        relative cursor-pointer rounded-lg py-2 px-5 border
        bg-gray-100 dark:bg-gray-800 text-blue dark:text-white border-transparent hover:text-orange
        font-medium w-full flex items-center justify-between text-lg md:text-xl
        ui-checked:bg-orange-50 ui-checked:text-orange ui-checked:border-orange-100
      "
      :value="value"
    >
      {{ text }}
      <icon name="hidden ui-checked:block fa-circle-check" set="duotone"/>
    </radio-group-option>
  </radio-group>
</template>

<script setup>
import Icon from "@/components/Icon.vue"
import { RadioGroup, RadioGroupLabel, RadioGroupOption } from "@headlessui/vue"
import { computed } from "vue"
import { processItems } from "@/selects"

const model = defineModel([String, Number, Boolean])

const props = defineProps({
  label: { type: String, required: true },
  items: { type: Array, required: true },
})

const items = computed(() => processItems(props.items))
</script>
